import { render, staticRenderFns } from "./importComponent.vue?vue&type=template&id=49338553&scoped=true"
import script from "./importComponent.vue?vue&type=script&lang=js"
export * from "./importComponent.vue?vue&type=script&lang=js"
import style0 from "./importComponent.vue?vue&type=style&index=0&id=49338553&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49338553",
  null
  
)

export default component.exports